// inputs.js
import { validateRequired,validateLength, validateDateRange }from "../../../../helpers/validationsForm";

const Inputs = [
  {
    id: 1,
    label: "Pedido N° ",
    name: "ord_id",
    type: "int",
    readOnly: true,
  },
  {
    id: 2,
    label: "Fecha de creacion en la APP",
    name: "ord_mobile_creation_date",
    type: "datetime",
    readOnly: true,
  },
  {
    id: 3,
    label: "Fecha de creacion en la nube",
    name: "createdAt",
    type: "datetime",
    readOnly: true,
  },  
  {
    id: 4,
    label: "Vendedor",
    name: "sel_name",
    type: "text",
    readOnly: true,
  },
  {
    id: 5,
    label: "Codigo del cliente",
    name: "cli_codigo",
    type: "text",
    readOnly: true,
  },
  {
    id: 6,
    label: "Razon Social",
    name: "razon_social",
    type: "text",
    readOnly: true,
  },
  {
    id: 7,
    label: "Nombre de Fantasia",
    name: "cli_name",
    type: "text",
    readOnly: true,
  },
  {
    id: 8,
    label: "Categoria del cliente",
    name: "cli_categoria",
    type: "text",
    readOnly: true,
  },
  {
    id: 9,
    label: "Direccion del cliente",
    name: "cli_direccion",
    type: "text",
    readOnly: true,
  },
  {
    id: 10,
    label: "Direccion de entrega",
    name: "cli_direccion_entrega",
    type: "text",
    readOnly: true,
  },
  {
    id: 11,
    label: "Tipo de Forma de Pago",
    name: "ord_pago_estado",
    type: "text",
    readOnly: true,
  },
  {
    id: 12,
    label: "Estado de Pago",
    name: "ord_state",
    type: "select",
    defaultValue: '0',
    options: [
      { value: '0', label: 'Pagado' },
      { value: '1', label: 'Pendiente' },
    ],
    placeholder: "Estado del Pago",
  },

  {
    id: 13,
    label: "Total",
    name: "monto_total",
    type: "float",
    readOnly: true,
  },
  {
    id: 14,
    label: "Descuento Aplicado",
    name: "desc_descripcion",
    type: "text",
    readOnly: true,
  },
  {
    id: 15,
    label: "Total(con  desc.)",
    name: "monto_total_desc",
    type: "float",
    readOnly: true,
  },
  {
    id: 16,
    label: "Tipo de Compra",
    name: "ord_datos_cli",
    type: "textarea",
    readOnly: true,
  },
];

export default Inputs;
